// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1024px){[data-v-ef185930]::-webkit-scrollbar{width:.5rem;cursor:pointer}}[data-v-ef185930]::-webkit-scrollbar-track{border-radius:9999px}@media (min-width:1024px){[data-v-ef185930]::-webkit-scrollbar-track{cursor:pointer;--tw-bg-opacity:1;background-color:rgba(209,213,219,var(--tw-bg-opacity))}[data-v-ef185930]::-webkit-scrollbar-thumb{cursor:pointer;border-radius:9999px;--tw-bg-opacity:1;background-color:rgba(156,163,175,var(--tw-bg-opacity))}}", ""]);
// Exports
module.exports = exports;
